import { render, staticRenderFns } from "./StationList.vue?vue&type=template&id=55d67370&scoped=true&"
import script from "./StationList.vue?vue&type=script&lang=js&"
export * from "./StationList.vue?vue&type=script&lang=js&"
import style0 from "./StationList.vue?vue&type=style&index=0&id=55d67370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d67370",
  null
  
)

export default component.exports